module.exports = __webpack_public_path__ + "img/coffin.82b8e307.svg";